import { type ProgramListDataObject } from './ProgramListDataObject';
import { type ProgramSlim, getProgramSlimData } from './ProgramSlim';

// TODO this belongs to global models
export type ProgramListItem = ProgramSlim;

export const getProgramListData = (data: ProgramListDataObject): ProgramListItem => ({
  ...getProgramSlimData(data),
});
